import React from 'react'
import { Link } from 'react-router-dom'
import useAuth from '../../context/hook/useAuth';
import { getAuth, signOut } from "firebase/auth";

import site from "../../utils/SiteSettings"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

export const Header = () => {

    const {dispatch,user} = useAuth()

    const userSignOut = getAuth();
    
    const hanldeClick = async (e) => {
            // e.preventDefault();
    
            try {
                
                signOut(userSignOut).then(() => {
                    localStorage.removeItem("cthash")
                    dispatch({
                        type: "LOGOUT",
                    })
                    setTimeout(()=>{
                        //this is used to redirect to login after the registered in successfully
                        // window.location.href="/login"
                        window.location.href="/login"
                    },2000)
                    toast.success("Sign-out successful",{position:'top-right'})
                // Sign-out successful.
                }).catch((error) => {
                    console.log(error)
                // An error happened.
                }); 
            } catch (error) {
                console.log(error)
            }
        }

  return (
    <div>
        {/* <!-- header start --> */}
        <header>
            <button className="navbar-toggler d-xl-none d-inline navbar-menu-button" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#primaryMenu">
                <span className="navbar-toggler-icon">
                <i className="fa-solid fa-bars"></i>
                </span>
            </button>
            <Link to={'/'} className="logo-text">
                {/* Coinstirs */}
                <img  src={require("../../../assets/logo.png")} className="img-fluid robot-img" alt="robot" />
            </Link>
            <nav className="header-nav-middle">
                <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                    <div className="offcanvas offcanvas-collapse order-xl-2" id="primaryMenu">
                        <div className="offcanvas-header navbar-shadow">
                            <h5 className="mb-0 vis-hidden">Back</h5>
                            <button className="btn-close lead" type="button" data-bs-dismiss="offcanvas"
                                aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link className="nav-link" to={"/buy/token"}>Buy {site?.site?.siteName}</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to={"/deposit"}>Deposit</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to={"/withdrawal"}>Withdraw</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to={"/setting"}>Settings</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to={"/support"}>Support</Link>
                                </li>
                                <li className="nav-item w-none">
                                {
                                    user ? (
                                        <Link data-cursor="pointer" to={''}  onClick={hanldeClick} className="nav-link"><span>Logout
                                        </span></Link>
                                        
                                    ):(
                                        <Link data-cursor="pointer" to={'/login'} className="nav-link"><span>Login
                                        Now</span></Link>
                                    )
                                }
                                    {/* <Link className="nav-link" to={"/login"}>Login</Link> */}
                                </li>
                                {/* <li className="nav-item">
                                    <Link className="nav-link" href="#faq">FAQ</Link>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
            {
                user ? (
                    <Link data-cursor="pointer" to={''}  onClick={hanldeClick} className="btn-solid d-sm-inline-block d-none"><span>Logout
                    </span></Link>
                    
                ):(
                    <Link data-cursor="pointer" to={'/login'} className="btn-solid d-sm-inline-block d-none"><span>Login
                    Now</span></Link>
                )
            }
        </header>
        {/* <!-- header end --> */}
    </div>
  )
}
